import React from 'react';

import { AccountSettings } from './AccountSettings';
import { useAuthState } from '../../authentication/context/authContext';
import { userProfileSelector } from '../../authentication/context/authSelectors';
import { UserProfile } from '../../../api/user-profile/userProfileTypes';

export const AccountSettingsContainer = () => {
  const state = useAuthState();
  return (
    <AccountSettings
      user={userProfileSelector(state) as UserProfile}
    />
  );
};

export default AccountSettingsContainer;
